import { FC, useState } from 'react';

import {
    Banner,
    Button,
    ButtonGroup,
    Drawer,
    Icon,
    Input,
    Stack,
} from '@servicetitan/design-system';

import { ApiGroup } from '../../api/app.api';
import { WebhookEventViewModel } from '../models/webhook-event-view-model';
import { WebhookEventTable } from './webhook-event-table';

export interface WebhookEventsDrawerProps {
    apiGroup: ApiGroup;
    viewModels: Map<string, WebhookEventViewModel>;
    onSubmit: () => void;
    onCancel: () => void;
}

export const WebhookEventsDrawer: FC<WebhookEventsDrawerProps> = ({
    apiGroup,
    viewModels,
    onSubmit,
    onCancel,
}) => {
    const [searchText, setSearchText] = useState('');
    const [errorsVisible, setErrorsVisible] = useState(false);
    const [errorBannerVisible, setErrorBannerVisible] = useState(false);

    return (
        <Drawer
            backdrop
            width="m"
            header="Webhook Events"
            footer={
                <ButtonGroup>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button
                        primary
                        onClick={() => {
                            if ([...viewModels.values()].every(viewModel => viewModel.urlValid)) {
                                onSubmit();
                            } else {
                                setErrorsVisible(true);
                                setErrorBannerVisible(true);
                            }
                        }}
                    >
                        Done
                    </Button>
                </ButtonGroup>
            }
            open
            onClose={onCancel}
        >
            <Stack direction="column" spacing={3} className="h-100">
                {errorBannerVisible && (
                    <Banner
                        icon
                        status="critical"
                        title="Please correct the errors shown below."
                        onClose={() => {
                            setErrorBannerVisible(false);
                        }}
                    />
                )}
                <Input
                    placeholder="Search"
                    shortLabel={<Icon name="search" />}
                    value={searchText}
                    onChange={(_event, data) => {
                        setSearchText(data.value);
                    }}
                />
                <Stack.Item fill className="min-h-0">
                    <WebhookEventTable
                        apiGroup={apiGroup}
                        viewModels={viewModels}
                        searchText={searchText}
                        errorsVisible={errorsVisible}
                    />
                </Stack.Item>
            </Stack>
        </Drawer>
    );
};
WebhookEventsDrawer.displayName = 'WebhookEventsDrawer';
